// extracted by mini-css-extract-plugin
export default {"InputElement":"Input_InputElement__lS-uv","Label":"Input_Label__hxAgH"};